import { createSelector } from 'reselect';

const buReducer = (state) => state.buReducer;

export const buSelector = createSelector(
    [buReducer],
    (buSlice) => {
        let buData = buSlice.businessUnits.bu;
        if (!Array.isArray(buData)) {
            return [];
        }

        return buData;
    },
);